import React from 'react';
import PropTypes from 'prop-types';
import { useOrderCustomForSlotHtml } from '@/hooks/api/order';

const CustomHtmlSlot = ({ slot }) => {
    const html = useOrderCustomForSlotHtml(slot);

    return (
        html && (
            <div
                data-custom-html-slot={slot}
                className="m2g-order-custom-html m2g-custom-html"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: html }}
            />
        )
    );
};

CustomHtmlSlot.propTypes = {
    slot: PropTypes.string.isRequired,
};

export default CustomHtmlSlot;
